import axios from 'axios';
import { Dayjs } from 'dayjs';
import { ApiUrl } from '@api/ApiUtils';

export interface BiddingEventRound {
  [key: string]: unknown;
  end_time: Dayjs;
  start_time: Dayjs;
}

export interface BiddingEventAttributes {
  [key: string]: unknown;
  end_at: Dayjs;
  end_time?: Dayjs;
  event_format: string;
  has_price_guidance_round: boolean;
  round_count: number;
  rounds_attributes: BiddingEventRound[];
  start_at: Dayjs;
}

export interface BidRequestData {
  bidding_event_attributes: BiddingEventAttributes | null;
  business_unit_id: number | null;
  contract_length: number;
  contract_length_unit: string;
  currency: string;
  description: string;
  end_time?: Dayjs;
  is_test: boolean;
  multi_award: boolean;
  name: string;
  one_off: boolean;
  open_for_viewing_at: Dayjs;
  send_event_reminders: boolean;
  spendCategoryId: number | null;
  start_time?: Dayjs;
  tag_names?: string[];
  template: boolean;
  time_zone: string;
  ui_config: Record<string, unknown>;
}

export const fetchSpendCategoryList = async () => {
  const url = ApiUrl('/spend_category_list');

  return axios.get(url);
};

export const createBidRequest = (data: BidRequestData) => {
  const url = ApiUrl('/bid_requests');

  return axios.post(url, data);
};
